/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileUser} from '@fortawesome/pro-duotone-svg-icons';

const HRIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFileUser} {...props} />
);

export default HRIcon;
